import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { formatRequestExport } from '@core/_utils/tools.utils';
import { MessagesService } from '@core/_services/messages.service';
import { Tools } from '@service/tools';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';

@Component({
    selector: 'exportdocs',
    templateUrl: 'exportdocs.component.html',
    styleUrls: ['exportdocs.component.scss'],
})
export class ExportDocsComponent implements OnInit, OnChanges {
    @Input() public selectedDocs;
    @Input()
    @Output()
    public visible: boolean;
    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();

    public fr: any;
    public error = false;
    public errorMessage = '';
    public selectedValueExport: string = 'optpdf';

    constructor(
        private api: ApiV6Service,
        public tools: Tools,
        protected _messageService: MessagesService,
        private translate:TranslateService
    ) {
    }

    public ngOnInit() {
    }

    public ngOnChanges() {}

    public async onClickExecExport() {
        let wRes: any;
        const wParams = formatRequestExport(this.selectedDocs, this.selectedValueExport);

        try {
            wRes = await lastValueFrom(this.api.execUrlAction('export', wParams));
            this._messageService.addSuccess(this.translate.instant('Batch_Send'));
            this.close(null);
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Batch_Send_KO'));
        }
    }

    public close(event) {
        this.visible = false;
        this.onClose.emit();
    }
}
